// @ts-nocheck

import { useEffect } from 'react';
import {
  Box,
  chakra,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import {
  useForm,
  useFormState,
} from 'react-final-form';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import RadioButtonField from '../form/RadioButtonField';
import FormBuilder from './FormBuilder';
import PriceLabel from '../form/PriceLabel';
import Summary from './Summary';

const PlanFormBuilder = ({
  config,
  children,
}: {
  config: IntakeConfig,
  children: ReactChildren,
}): JSX.Element => {
  const form = useForm();
  const formState = useFormState();
  const { country } = formState.values.address;
  const plan = config.plan.countries[country];
  const selectedPeriod = plan.periods.find(p => p.id === formState.values.plan);
  useEffect(
    () => {
      if (selectedPeriod) return;
      form.change('plan', plan.periods[0].id);
    },
    [],
  );

  return (
    <Flex direction={['column', , 'row']} align="stretch" gap="2em" width="100%">
      <Flex direction="column" gap="3em" align="stretch" width={['100%', , '66%']}>
        <Box alignSelf="flex-end">
          <Flex direction="row" gap="1em" wrap="wrap" align="center">
            <Heading size="md">Billing</Heading>
            {plan.periods.map(p => (
              <RadioButtonField size="xs" name="plan" value={p.id} label={p.label} key={p.id} />
            ))}
          </Flex>
        </Box>
        <Flex direction="row" gap="1em" width="100%">
          <Box flexGrow={1}>
            <Heading size="md">{plan.label}</Heading>
            <Text>{plan.description}</Text>
          </Box>
          <PriceLabel price={selectedPeriod?.price} unit={selectedPeriod?.unit} />
        </Flex>
        <FormBuilder addons={selectedPeriod?.addons} />
        {children}
      </Flex>
      <Flex direction="column" w="100%" flex="1" position="relative" bg="gray.50">
        <chakra.div
          display={['none', , 'block']}
          bg="gray.50"
          position="fixed"
          h="9999px"
          w="100%"
          top="0"
          zIndex={-1}
        />
        <Box p="2em" w="100%" position="relative">
          <Summary config={config} />
        </Box>
      </Flex>
    </Flex>
  );
};

export default PlanFormBuilder;
